<template>
  <dl class="review-record-anatomy" aria-label="Guidance for report assessment">
    <div>
      <dt>Evidence needed</dt>
      <dd>I broke each risk’s decision criteria down into the facts needed to apply them. These requirements guide extraction and help the model identify missing context before reaching a conclusion.</dd>
    </div>
    <div>
      <dt>Where to look</dt>
      <dd>Optional source guidance identifies report sections, tables and supporting records likely to contain useful context. It can help focus a return to the source when an assessment needs more detail.</dd>
    </div>
    <div>
      <dt>Decision rules</dt>
      <dd>The rules explain how the collected observations support or qualify a finding. Each risk has its own criteria, applied during synthesis after the evidence has been gathered.</dd>
    </div>
  </dl>
</template>
<script>
export default { name: 'RiskAssessmentGuide' };
</script>
<style scoped src="./detailColumns.css"></style>
